/* eslint-disable max-len */
import OntQuestion from 'images/coin-pages/questions/ont.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const ontPage: ICoinPageData = {
  title: 'coin_747',
  description: 'coin_748',
  // description: 'coin_749',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Ontology (ONT)' }) }}
    />
  ),
  questionsBlock: {
    image: OntQuestion,
    questions: [
      {
        title: 'coin_750',
        answer: 'coin_751',
      },
      {
        title: 'coin_752',
        answer: 'coin_753',
      },
      {
        title: 'coin_754',
        answer: 'coin_755',
      },
      {
        title: 'coin_756',
        answer: 'coin_757',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('OKB (OKB)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_758',
        text: ['coin_760'],
      },
      {
        title: 'coin_759',
        text: ['coin_761'],
      },
    ],
    blogCards: [
      blogCards.borrowLikePro,
      {
        link: 'https://coinrabbit.io/blog/what-is-ont-crypto-and-how-to-use-it-to-gain-profit2023-update/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400,h_1256/https://coinrabbit.io/blog/wp-content/uploads/2023/06/Gain-profit-5.jpg',
        imageAlt: 'What is ONT crypto',
      },
      blogCards.whatTypesOfCryptoLoansAreThereAndHowCanIProfitFromIt,
    ],
  },
}
